import { Box } from '@mui/material';
import { Button } from 'react-admin';
import { useCreatePath } from 'ra-core';
import { Link } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

import { showAsideSx } from '@/components/layout/showPageLayout';

export const TicketAside = () => {
    const createPath = useCreatePath();

    return (
        <Box sx={showAsideSx}>
            <Box my={2}>
                <Button
                    component={Link}
                    to={createPath({ resource: 'tickets', type: 'list' })}
                    label="Back"
                >
                    <ArrowBackIcon />
                </Button>
            </Box>
        </Box>
    );
};
